import { useEffect } from "react";

import "../../assets/css/product.scss";
import Header from "../../components/header";
import Footer from "../../components/footer";

import benefit01Svg from "../../assets/images/benefit_01.svg";
import benefit02Svg from "../../assets/images/benefit_02.svg";
import benefit03Svg from "../../assets/images/benefit_03.svg";
import benefit04Svg from "../../assets/images/benefit_04.svg";
import benefit05Svg from "../../assets/images/benefit_05.svg";
import subscriptionInfo01Svg from "../../assets/images/icons/subscription_info01.svg";
import subscriptionInfo02Svg from "../../assets/images/icons/subscription_info02.svg";
import subscriptionInfo03Svg from "../../assets/images/icons/subscription_info03.svg";
import subscriptionInfo04Svg from "../../assets/images/icons/subscription_info04.svg";
import subscriptionInfo05Svg from "../../assets/images/icons/subscription_info05.svg";
import { useSearchParams } from "react-router-dom";
import DonationModalContainer from "../../components/modal/donate_modal_container";
import { useDonationModal } from "../../hooks/use_donation_modal";

function DonationPage() {
  const [searchParams] = useSearchParams();
  const kdBusiness = searchParams.get("kd_business");

  const donationModal = useDonationModal();

  useEffect(() => {
    donationModal.resetModalState();
  }, []);

  return (
    <div className="product-container">
      <Header />
      <ul className="section1">
        <li className="title">
          나에게 맞는 <span>어린이동아 이용권</span>을 선택해 보세요.
        </li>
        <li className="sub-title">어린이 동아의 놀라운 컨텐츠를 만나보세요.</li>
        <li className="product-subscription-box">
          <ul>
            <li className="box donation">
              <div className="overflow-box">
                <div>Donation</div>
                <div>
                  <ul>
                    <li></li>
                    <li>구독 기부</li>
                    <li>구독권을 기부하실수 있습니다.</li>
                    <li>
                      <button
                        onClick={() => donationModal.startDonationProcess("0")}
                      >
                        기부하기
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="divider"></div>
                <div>어린이동아 NIE 후원 캠페인</div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
      <div className="section2">
        <ul className="section2-container">
          <li className="title">
            어린이동아의 <span>차별화된 혜택</span>
          </li>
          <li className="benefit-box">
            <ul>
              <li>
                <img src={benefit01Svg} alt="" />
              </li>
              <li>맞춤형 뉴스</li>
              <li>
                60년이 넘는 전통을 가진 국내 대표 초등생 신문 ‘어린이동아‘의
                초등생 맞춤형 뉴스를 손 안 에서 매일 배송 받아보세요.
                ‘어린이동아’는 우리나라를 비롯해 세계 곳곳에서 매일 쏟아지는
                다양한 뉴스를 초등생의 눈높이에 맞춰 제시하는 독자 친화적인
                일간지입니다.
              </li>
            </ul>
            <ul>
              <li>
                <img src={benefit02Svg} alt="" />
              </li>
              <li>교과 학습 콘텐츠</li>
              <li>
                ‘어린이동아’ 앱에선 신문 지면을 통해선 만나볼 수 없는 차별화된
                기사와 학습 콘텐츠가 제공됩니다. 모든 뉴스는 초등생들의 국어,
                수학, 사회, 과학 교과 학습과 연관된 학습 콘텐츠 형태로 제공되고,
                초등생들은 이를 통해 교과와 연관된 문제를 풀게 됩니다.
              </li>
            </ul>
            <ul>
              <li>
                <img src={benefit03Svg} alt="" />
              </li>
              <li>보호자의 관리 기능</li>
              <li>
                ‘어린이동아’ 앱은 초등생과 그들의 부모‧교사가 뉴스로 소통하며
                학습하도록 합니다. 초등생이 뉴스를 읽고 수행한 활동은 보호자가
                즉각 확인할 수 있습니다. 이를 통해 부모‧교사는 그 자녀‧학생들의
                뉴스 읽기를 유도하고, 독려하며, 확인할 수 있습니다.
              </li>
            </ul>
            <ul>
              <li>
                <img src={benefit04Svg} alt="" />
              </li>
              <li>스터디 & 라이프 </li>
              <li>
                초등생 독자가 뉴스를 읽고 활동하면 앱에서 포인트가 쌓입니다.
                이를 활용해 앱 내에서 웹툰을 보고, 게임을 하거나 생활용품을
                구매할 수도 있습니다.
              </li>
            </ul>
            <ul>
              <li>
                <img src={benefit05Svg} alt="" />
              </li>
              <li>차별화된 교육 정보</li>
              <li>
                학부모들은 자녀의 진로·진학 등 엄선된 교육·입시 정보를 누구보다
                빨리 취득할 수 있습니다.
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div className="section3">
        <div className="title">
          구독 서비스 <span>상세정보</span>
        </div>
        <div className="sub-title">
          한 보호자가 어린이동아를 구독할 경우,
          <br />
          최대 3명의 자녀가 함께 구독 서비스를 이용할 수 있습니다.
        </div>
        <ul className="subscription-info-box">
          <li>
            <div>
              <img src={subscriptionInfo01Svg} alt="" />
            </div>
            <div className="pc">
              맞춤형
              <br />
              일간 뉴스 제공
            </div>
            <div className="mobile">맞춤형 일간 뉴스 제공</div>
          </li>
          <li>
            <div>
              <img src={subscriptionInfo02Svg} alt="" />
            </div>
            <div className="pc">
              교과 학습
              <br />
              콘텐츠 제공
            </div>
            <div className="mobile">교과 학습 콘텐츠 제공</div>
          </li>
          <li>
            <div>
              <img src={subscriptionInfo03Svg} alt="" />
            </div>
            <div className="pc">
              앱 내<br />
              포인트 적립 제공
            </div>
            <div className="mobile">앱 내 포인트 적립 제공</div>
          </li>
          <li>
            <div>
              <img src={subscriptionInfo04Svg} alt="" />
            </div>
            <div className="pc">
              보호자의 자녀
              <br />
              관리 기능 제공
            </div>
            <div className="mobile">보호자의 자녀 관리 기능 제공</div>
          </li>
          <li>
            <div>
              <img src={subscriptionInfo05Svg} alt="" />
            </div>
            <div className="pc">기타</div>
            <div className="mobile">기타</div>
          </li>
        </ul>

        <div className="service-notice-container">
          <div>서비스 이용 유의사항</div>
          <ul>
            <li>상기금액은 부가세 포함된 금액입니다.</li>
            <li>
              구입하신 구독권은 결제내역 관리페이지에서 확인할 수
              있습니다.&nbsp;
              <a href="/product_step1">결제내역 바로가기</a>
            </li>
            <li>
              기부내역은 기부내역 페이지에서 확인할 수 있습니다. &nbsp;
              <a href="/donation_step1">기부내역 바로가기</a>
            </li>
            <li>
              결제 완료 시 인증하신 휴대폰번호로 즉시 구독권이 발송됩니다.
            </li>
            <li>
              휴대폰 번호를 변경하신 경우, 이전 휴대폰 번호로 구매한 이력을
              조회할 수 없습니다. 고객센터에 문의하시길 바랍니다.
            </li>
            <li>
              구입하신 구독권은 어린이동아 앱내 My &gt; 쿠폰 등록 페이지에서
              사용할 수 있습니다.
            </li>
            <li>
              유료 구독 서비스 특성상, 이미 제공된 콘텐츠에 대해서는 환불이
              제한될 수 있습니다.
              <br />
              환불은 고객의 신청일 기준 이용 여부 및 남은 기간을 고려하여
              합리적으로 산정됩니다.
              <br />
              결제일 기준 초기 일정 기간내 환불요청이 있을 경우, 콘텐츠 미이용
              시 전액 환불을 원칙으로 합니다.
              <br />
              환불시 평가기준 월 단위 사용료를 차감한 후 잔여 금액을 반환합니다.
              (할인 금액은 환불 대상에서 제외)
              <br />
              <a
                href="https://kidsdonga.com/application/service.html#a12"
                target="_blank"
                rel="noreferrer"
              >
                환불정책 바로가기
              </a>{" "}
              자세한 환불정책을 확인하실 수 있습니다.
            </li>
            <li>
              유료 사용자에게 제공된 기능은 이용 기간만료 후에는 사용할 수
              없습니다.
            </li>
          </ul>
        </div>
      </div>
      <Footer />

      <DonationModalContainer
        {...donationModal}
        kdBusiness={kdBusiness}
        paymentType="" // DonationPage의 경우 빈 문자열 또는 다른 값
      />
    </div>
  );
}

export default DonationPage;
